/* ===== TLL THEME JS =====
   Header + footer + cart drawer + product form behaviors for the live theme.
   Uses Shopify's AJAX Cart API: /cart.js, /cart/add.js, /cart/change.js
*/
(function () {

  // ===== UTILITIES =====
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  function fmt(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // ===== HEADER: search + account dropdown =====
  ready(function () {
    var searchBtn   = document.getElementById('hdr-search-btn');
    var searchBar   = document.getElementById('hdr-search');
    var searchClose = document.getElementById('hdr-search-close');
    var acctBtn     = document.getElementById('hdr-account-btn');
    var acctMenu    = document.getElementById('hdr-account-menu');

    function openSearch() {
      if (!searchBar) return;
      searchBar.hidden = false;
      setTimeout(function () {
        var input = searchBar.querySelector('input');
        if (input) input.focus();
      }, 30);
    }
    function closeSearch() { if (searchBar) searchBar.hidden = true; }

    function openAcct()  { if (!acctMenu) return; acctMenu.hidden = false; acctBtn.setAttribute('aria-expanded', 'true'); }
    function closeAcct() { if (!acctMenu) return; acctMenu.hidden = true;  acctBtn.setAttribute('aria-expanded', 'false'); }

    if (searchBtn) searchBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (searchBar.hidden) openSearch(); else closeSearch();
    });
    if (searchClose) searchClose.addEventListener('click', closeSearch);

    if (acctBtn) acctBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (acctMenu.hidden) openAcct(); else closeAcct();
    });

    document.addEventListener('click', function (e) {
      if (acctMenu && !acctMenu.hidden && !acctMenu.contains(e.target) && e.target !== acctBtn) closeAcct();
    });
    // ===== MOBILE DRAWER =====
    var burgerBtn = document.getElementById('hdr-burger-btn');
    var drawer    = document.getElementById('hdr-mobile-drawer');

    function openDrawer() {
      if (!drawer) return;
      drawer.hidden = false;
      if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.hidden = true;
      if (burgerBtn) burgerBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    if (burgerBtn) {
      burgerBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (drawer && drawer.hidden) openDrawer(); else closeDrawer();
      });
    }
    if (drawer) {
      drawer.addEventListener('click', function (e) {
        if (e.target.hasAttribute('data-drawer-close')) closeDrawer();
      });
      // Close drawer when any nav link inside it is clicked (let nav happen first)
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () {
          setTimeout(closeDrawer, 50);
        });
      });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (searchBar && !searchBar.hidden) closeSearch();
        if (acctMenu && !acctMenu.hidden) closeAcct();
        if (drawer && !drawer.hidden) closeDrawer();
      }
    });
  });

  // ===== CART DRAWER =====
  ready(function () {
    var drawer = document.getElementById('cart-drawer');
    if (!drawer) return;

    var overlay   = drawer.querySelector('.cart-drawer__overlay');
    var closeBtn  = drawer.querySelector('.cart-drawer__close');
    var keepBtn   = drawer.querySelector('.cart-drawer__keep');
    var itemsEl   = document.getElementById('cart-items');
    var toast     = document.getElementById('cart-toast');
    var sub       = document.getElementById('cart-sub');
    var tot       = document.getElementById('cart-total');
    var cartBtn   = document.getElementById('hdr-cart-btn');
    var countEl   = document.querySelector('.hdr__count');

    function openDrawer(toastMsg) {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (toastMsg && toast) {
        toast.textContent = toastMsg;
        toast.classList.add('is-shown');
        setTimeout(function () { toast.classList.remove('is-shown'); }, 2200);
      }
    }
    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function renderCart(cart) {
      if (!cart || !cart.items || cart.items.length === 0) {
        itemsEl.innerHTML = '<div class="cart-drawer__empty">★ your cart is dry · go pick something ★</div>';
      } else {
        itemsEl.innerHTML = cart.items.map(function (it) {
          return '<div class="cart-drawer__item" data-key="' + it.key + '">'
            +   '<div class="cart-drawer__item-thumb"><img src="' + (it.image || '') + '" alt=""></div>'
            +   '<div class="cart-drawer__item-info">'
            +     '<p class="cart-drawer__item-name">' + it.product_title + '</p>'
            +     '<span class="cart-drawer__item-meta">' + fmt(it.price) + ' ea</span>'
            +     '<div class="cart-drawer__item-qty">'
            +       '<button data-act="dec" aria-label="Decrease quantity">–</button>'
            +       '<span>' + it.quantity + '</span>'
            +       '<button data-act="inc" aria-label="Increase quantity">+</button>'
            +     '</div>'
            +   '</div>'
            +   '<div class="cart-drawer__item-side">'
            +     '<span class="cart-drawer__item-price">' + fmt(it.line_price) + '</span>'
            +     '<button class="cart-drawer__item-remove" data-act="rm">remove</button>'
            +   '</div>'
            + '</div>';
        }).join('');
      }
      if (sub) sub.textContent = fmt(cart.items_subtotal_price);
      if (tot) tot.textContent = fmt(cart.total_price);
      if (countEl) countEl.textContent = cart.item_count;
      if (cartBtn && cart.item_count === 0 && countEl) countEl.remove();
    }

    function fetchCart(then) {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) { renderCart(cart); if (then) then(cart); })
        .catch(function (e) { console.error('[cart] fetch failed', e); });
    }

    function changeLine(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(function (r) { return r.json(); })
        .then(renderCart)
        .catch(function (e) { console.error('[cart] change failed', e); });
    }

    // qty +/-/remove
    if (itemsEl) itemsEl.addEventListener('click', function (e) {
      var btn = e.target.closest('button');
      if (!btn) return;
      var wrap = btn.closest('.cart-drawer__item');
      if (!wrap) return;
      var key = wrap.dataset.key;
      var qtyEl = wrap.querySelector('.cart-drawer__item-qty span');
      var qty = parseInt(qtyEl.textContent, 10) || 1;
      if (btn.dataset.act === 'inc') changeLine(key, qty + 1);
      else if (btn.dataset.act === 'dec') changeLine(key, Math.max(0, qty - 1));
      else if (btn.dataset.act === 'rm') changeLine(key, 0);
    });

    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    keepBtn.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    if (cartBtn) cartBtn.addEventListener('click', function (e) {
      e.preventDefault();
      fetchCart(function () { openDrawer(); });
    });

    // ===== PDP product form (action=/cart/add) → AJAX submit =====
    var pdpForm = document.getElementById('pdp-form');
    if (pdpForm) {
      pdpForm.addEventListener('submit', function (e) {
        e.preventDefault();
        var fd = new FormData(pdpForm);
        var btn = pdpForm.querySelector('button[type=submit]');
        var originalText = btn ? btn.textContent : '';
        if (btn) btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: fd
        })
          .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
          .then(function (res) {
            if (!res.ok) {
              if (btn) { btn.textContent = res.data.description || 'Add failed'; setTimeout(function () { btn.textContent = originalText; btn.disabled = false; }, 1800); }
              return;
            }
            if (btn) {
              btn.classList.add('is-added');
              btn.textContent = '★ added to bag';
              setTimeout(function () {
                btn.classList.remove('is-added');
                btn.textContent = originalText;
                btn.disabled = false;
              }, 700);
            }
            fetchCart(function () { setTimeout(function () { openDrawer('★ added — that\'s the vibe'); }, 200); });
          })
          .catch(function (err) {
            console.error('[cart] add failed', err);
            if (btn) { btn.disabled = false; btn.textContent = originalText; }
          });
      });
    }

    // Initial cart count
    fetchCart();
  });

  // ===== PDP qty stepper + variant selection =====
  ready(function () {
    var qtyInput = document.getElementById('pdpi-qty');
    var qtyHidden = document.getElementById('pdp-quantity');
    if (qtyInput) {
      var minus = document.getElementById('pdpi-qty-minus');
      var plus  = document.getElementById('pdpi-qty-plus');
      function sync() { if (qtyHidden) qtyHidden.value = qtyInput.value; }
      if (minus) minus.addEventListener('click', function () { var q = parseInt(qtyInput.value,10)||1; qtyInput.value = Math.max(1, q-1); sync(); });
      if (plus)  plus.addEventListener('click',  function () { var q = parseInt(qtyInput.value,10)||1; qtyInput.value = Math.min(99, q+1); sync(); });
    }

    // Size/color chip selection — toggle .is-active and update hidden inputs
    document.querySelectorAll('.pdpi__chips').forEach(function (group) {
      group.addEventListener('click', function (e) {
        var chip = e.target.closest('.pdpi__chip');
        if (!chip) return;
        group.querySelectorAll('.pdpi__chip').forEach(function (n) { n.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var pickLabel = group.parentElement.querySelector('[id$="-pick"]');
        if (pickLabel) pickLabel.textContent = '· ' + chip.dataset.value;

        // Update hidden form input
        var name = group.dataset.optionName;
        var hidden = document.getElementById('pdp-prop-' + (name || '').toLowerCase());
        if (hidden) hidden.value = chip.dataset.value;

        // Update variant ID if this is a real Shopify option
        updateVariantId();
      });
    });
  });

  function updateVariantId() {
    var form = document.getElementById('pdp-form');
    if (!form) return;
    var variantInput = document.getElementById('pdp-variant-id');
    if (!variantInput) return;
    var variants = window.TLL_PRODUCT_VARIANTS;
    if (!variants) return;

    var picks = {};
    document.querySelectorAll('.pdpi__chips .is-active').forEach(function (c) {
      var name = c.closest('.pdpi__chips').dataset.optionName;
      if (name) picks[name] = c.dataset.value;
    });

    var match = variants.find(function (v) {
      return Object.keys(picks).every(function (k) {
        return v.options.indexOf(picks[k]) !== -1;
      });
    });
    if (match) variantInput.value = match.id;
  }

  // ===== Cart link interceptor — preview-only fallback for non-Shopify envs =====
  // (No-op on real Shopify because /cart.js exists.)

})();
